<template>
    <footer>
        <img src="../assets/images/logo_yostar.png" alt="" class="logo">
        <img src="../assets/images/logo_maoliang.png" alt="" class="logo maoliang">
        <div class="text">
            <div class="item">
                <a href="https://mahjongsoul.yo-star.com/privacy_policy">PRIVACY POLICY</a>
                <a href="https://mahjongsoul.yo-star.com/terms_of_service">TERMS OF USE</a>
                <a href="mailto:mjs.cs@yo-star.com"> CONTACT US</a>
            </div>
            <div class="copyright">
                <p>&copy;2019 SOULCREATOR NETWORK TECHNOLOGY CO.,LTD</p>
                <p>&copy;2019 YOSTAR (HONGKONG) LIMITED</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'vfooter',
  data: () => ({
  })
}
</script>

<style lang="scss" scoped>
footer {
    width: 100%;
    padding: pxTorem(40px) 0 pxTorem(40px);
    background: #000000;
    text-align: center;
    font-size: 0;

    @media screen and (max-width: 600px) {
        padding: MpxTorem(24px) 0 MpxTorem(19px);
    }

    .logo {
        display: inline-block;
        height: pxTorem(30px);
        @media screen and (max-width: 600px) {
            height: MpxTorem(26px);
        }
    }

    .maoliang {
        margin-left: pxTorem(20px);
        height: pxTorem(30px);
        @media screen and (max-width: 600px) {
            height: MpxTorem(26px);
        }
    }

    .text {
        display: inline-block;
        margin-left: pxTorem(80px);
        vertical-align: middle;
        text-align: center;
        color: #fff;
        margin-top: pxTorem(-7px);

        @media screen and (max-width: 600px) {
            width: 100%;
            margin-left: 0;
            margin-top: MpxTorem(24px);
        }

        .item {
            margin-bottom: pxTorem(15px);
            font-size: pxTorem(11px);

            a {
                padding: 0 pxTorem(12px);
                cursor: pointer;
                color: #fff;
                &:not(:last-child) {
                    border-right: 1px solid #fff;
                }
                &:hover {
                    color: #f5ed00;
                }
                @media screen and (max-width: 600px) {
                    font-size: MpxTorem(8px);
                }
            }
        }
        .copyright {
            font-size: pxTorem(10px);
            p:not(:last-child) {
                margin-bottom: pxTorem(1px);
            }
            @media screen and (max-width: 600px) {
                font-size: MpxTorem(7px);
            }
        }
    }
}
</style>
